<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15.52,2.77C15.82,2.48,16,2.07,16,1.62C16,0.73,15.27,0,14.38,0C13.93,0,13.53,0.18,13.23,0.48C13.23,0.48,11.89,1.82,11.89,1.82C11.89,1.82,14.19,4.12,14.19,4.12C14.19,4.12,15.52,2.77,15.52,2.77C15.52,2.77,15.52,2.77,15.52,2.77ZM7.4,10.9C7.4,10.9,13.61,4.69,13.61,4.69C13.61,4.69,11.31,2.39,11.31,2.39C11.31,2.39,5.1,8.6,5.1,8.6C5.1,8.6,7.4,10.9,7.4,10.9C7.4,10.9,7.4,10.9,7.4,10.9ZM14,14C14,14,2,14,2,14C2,14,2,2,2,2C2,2,8.34,2,8.34,2C8.34,2,10.34,0,10.34,0C10.34,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,15,0,15C0,15.55,0.45,16,1,16C1,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,5.66,16,5.66C16,5.66,14,7.66,14,7.66C14,7.66,14,14,14,14C14,14,14,14,14,14ZM3,13C3,13,6.58,11.71,6.58,11.71C6.58,11.71,4.29,9.44,4.29,9.44C4.29,9.44,3,13,3,13C3,13,3,13,3,13Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Annotation',
} as DefineComponent
</script>
